import { object, string, number } from 'yup'

export const productOriginValidationSchema = object({
  name: string()
    .trim()
    .required('El campo Nombre Marca en WMS es requerido.')
    .min(1, 'Debe ingresar al menos 1 caracter')
    .max(200, 'Máximo 200 caracteres.'),
  typeStorageId: number()
    .required('Debe seleccionar el tipo de almacenamiento.')
    .oneOf([1, 2, 3], 'Debe seleccionar un tipo de almacenamiento válido.'),
  expirationDays: number()
    .nullable()
    .when('hasExpirationDays', {
      is: true,
      then: (schema) =>
        schema
          .required('Debe ingresar los días mínimos antes del vencimiento.')
          .min(1, 'Debe ser mayor a 0'),
      otherwise: (schema) => schema.nullable()
    })
})
